var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-playstore"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "playstore",
    clipPath: "url(#clip-playstore)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "google-play",
    d: "M2.161.351,9.722,4.7,8.1,6.319ZM.595,0l6.94,6.913L.6,13.826a.991.991,0,0,1-.6-.907c0-.013,0-.026,0-.039V.945C0,.934,0,.921,0,.908A.99.99,0,0,1,.589,0L.6,0ZM12.072,6.1a.961.961,0,0,1,.391.774c0,.013,0,.025,0,.037v0c0,.025,0,.054,0,.084a.9.9,0,0,1-.366.725l0,0-1.621.918L8.722,6.913l1.755-1.755ZM2.161,13.475,8.1,7.507,9.722,9.128Z",
    transform: "translate(1 0.1)",
    fill: "#8896af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.ad1113aae1a932c048980b9dcc029aca.svg";
export { ForwardRef as ReactComponent };